var useSubmissionSource = function useSubmissionSource() {
  return {
    setSubmissionSource: function setSubmissionSource(submissionSource) {
      sessionStorage.setItem('submission_source', submissionSource);
    },
    getSubmissionSource: function getSubmissionSource() {
      return sessionStorage.getItem('submission_source');
    },
    getAndRemoveSubmissionSource: function getAndRemoveSubmissionSource() {
      var source = sessionStorage.getItem('submission_source');
      sessionStorage.removeItem('submission_source');
      return source || null;
    },
    removeSubmissionSource: function removeSubmissionSource() {
      sessionStorage.removeItem('submission_source');
    }
  };
};
export default useSubmissionSource;